import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addDocumentupload = (postData) => {
  return http().post(endpoints.forms.documentUpload, postData);
};

export function useDocumentupload() {
  return useMutation(addDocumentupload, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
